import { actionTypes } from 'actions/actionTypes'
import statusActions from 'actions/status'
import { trackCheckoutError } from 'actions/tracking'
import { fetchAddressByPostcode } from 'apis/addressLookup'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'
import logger from 'utils/logger'

export const checkoutAddressLookup: CheckoutActionCreator =
  (postcode: string) => async (dispatch) => {
    dispatch(statusActions.pending(actionTypes.CHECKOUT_ADDRESSES_RECEIVE, true))
    dispatch(statusActions.error(actionTypes.CHECKOUT_ADDRESSES_RECEIVE, null))

    const addresses: {
      deliveryPoints: unknown[]
      postcode: string
      town?: string
      county?: string
    } = {
      deliveryPoints: [],
      postcode,
    }

    try {
      const lookupResults = await fetchAddressByPostcode(postcode)

      addresses.deliveryPoints = lookupResults.data.deliveryPoints || []
      addresses.town = lookupResults.data.town
      addresses.postcode = lookupResults.data.postcode || postcode
      addresses.county = lookupResults.data.traditionalCounty || ''
    } catch (err) {
      dispatch(
        trackCheckoutError(
          actionTypes.CHECKOUT_ADDRESSES_RECEIVE,
          (err as Error).message,
          'checkoutAddressLookup',
        ),
      )
      dispatch(statusActions.error(actionTypes.CHECKOUT_ADDRESSES_RECEIVE, (err as Error).message))
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      logger.error({ message: 'Unable to look-up address' })
    } finally {
      dispatch(statusActions.pending(actionTypes.CHECKOUT_ADDRESSES_RECEIVE, false))
    }

    return addresses
  }
